<template>
  <div class="block-wrapper">
    <div class="block-head clearfix">
      <i  v-show="iconShow" class="iconfont icon-dengpao"></i><h4 class="name">{{ name }}</h4><i class="msgRight hoverStyle" @click.stop.prevent="getMore" v-show="blockShow">{{ msgRight }}</i>
    </div>
    <slot class="slot"></slot>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: '推荐机构'
    },
    msgRight: {
      type: String,
      default: '全部'
    },
    blockShow: {
      type: Boolean,
      default: true
    },
    iconShow: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    getMore () {
      this.$emit('getMore')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/scss" lang="scss" scoped>
@import '~@/styles/base.scss';
  .block-head {
    width: 100%;
    height: 42px;
    vertical-align: middle;
    line-height: 42px;
    text-align: left;
    // font-weight: 700;
    color: $grayColor;
    .name {
      float: left;
      font-size: 24px;
      line-height: 42px;
    }
    .iconfont {
      float: left;
      font-size: 60px;
      color: #2A8DDF;
    }
    .msgRight {
      float: right;
      margin-right: 10px;
      font: 14px/42px "microsoft yahei",Arial;
      color: $grayColor;
      cursor: pointer;
    }
  }
  .slot {
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/block-wrapper/block-wrapper.vue